import '@fontsource-variable/vazirmatn';
import './index.css';
import { mount } from 'svelte';
import { z } from 'zod';
import App from './app/App.svelte';
import { startSessionKeeper } from './shared/auth/session-keeper';
import { startErrorReporting } from './shared/diag/report';
import { startPwa } from './shared/pwa/update.svelte';
import { interceptLinks } from './shared/router/router.svelte';
import { startTheme } from './shared/theme/theme.svelte';

// First, so a failure while the app starts reaches the server log too.
startErrorReporting();
// Before anything renders, so a member's chosen theme does not flash the device's one.
startTheme();
// Client-side validation messages in Persian (same locale as the API).
z.config(z.locales.fa());

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing');
interceptLinks();
// Safari on iPhone ignores `user-scalable=no` in the viewport meta; its pinch starts here.
document.addEventListener('gesturestart', (e) => e.preventDefault());
mount(App, { target: root });
startPwa();
// Renews the access token before it runs out, so no tap meets an expired one.
startSessionKeeper();
